import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconActivitySurfingComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.5"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1223_1965)">
          <path d="M23.2175 17.8734C17.8533 17.8734 14.2394 15.9967 13.3025 12.7245C12.6265 10.3638 13.5921 8.03927 14.8742 7.23953C15.315 6.96461 15.5828 6.9498 16.1008 6.9266C16.6455 6.97239 17.2076 7.2498 17.7679 7.75554C18.8634 8.74432 18.7783 10.9702 18.722 12.4431C18.6888 13.313 18.6688 13.8381 18.848 14.2231C19.052 14.6613 19.5087 14.8733 20.0113 14.7634C20.7845 14.5943 21.6233 13.6675 22.1505 12.8564C22.9198 11.6729 23.3472 10.3063 23.3539 9.00837C23.3657 6.70563 22.4506 4.75947 20.7075 3.37998C19.1473 2.14529 16.9853 1.45355 14.62 1.43218C11.0883 1.39993 7.54486 2.81607 4.90138 5.31892C2.71302 7.39099 0.0868894 11.2152 0.00345176 17.6672C-0.017267 19.2684 0.0645769 20.6793 0.00462364 21.7417C-0.0207358 22.1905 0.336921 22.5683 0.785891 22.5683C2.91135 22.5683 21.0426 22.5683 23.2175 22.5683C23.6497 22.5683 24 22.218 24 21.7859V18.6559C24 18.2237 23.6497 17.8734 23.2175 17.8734ZM1.59097 21.0033C1.59852 20.0238 1.55253 18.9062 1.56828 17.6875C1.70506 7.11494 9.13416 2.94259 14.6057 2.99725C18.1963 3.02968 21.8098 4.89845 21.7887 9.00035C21.7803 10.6623 20.9215 12.0254 20.2773 12.729C20.2801 12.6522 20.2829 12.576 20.2857 12.5029C20.3531 10.7388 20.455 8.07283 18.8163 6.59383C17.8834 5.75177 16.8695 5.33308 15.8771 5.3507C13.8691 5.3133 11.9199 5.80445 10.2226 6.78096C6.78276 8.76021 4.67727 12.4998 4.68726 16.3812C4.69138 17.9757 5.05724 19.5507 5.75385 21.0033H1.59097ZM7.52447 21.0034C5.35157 17.2768 6.05039 12.8333 8.85183 9.83585C8.28544 10.951 7.95117 12.2092 7.88475 13.5221C7.77801 15.6318 8.37 17.6794 9.55163 19.2878C10.0407 19.9536 10.6165 20.5272 11.268 21.0034H7.52447ZM22.4351 21.0034H15.4052C11.0639 20.3739 9.28406 16.8378 9.44785 13.6012C9.54816 11.6179 10.4064 9.59581 12.0924 8.3029C11.4312 9.83431 11.3498 11.5899 11.798 13.1555C12.3158 14.964 13.5086 16.4888 15.2473 17.5653C17.0931 18.708 19.5083 19.3328 22.4351 19.4263L22.4351 21.0034Z" />
        </g>
        <defs>
          <clipPath id="clip0_1223_1965">
            <rect fill="white" height="24" width="24" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

IconActivitySurfingComponent.displayName = 'IconActivitySurfing';

const IconActivitySurfing = React.memo(IconActivitySurfingComponent);

export default IconActivitySurfing;
